import React from "react";
import { RotateCcw, Search, Settings, Radio, RefreshCw, CheckCircle2, XCircle, Video, Image as ImageIcon } from "lucide-react";

/**
 * Shared per-file upload status glyph — used by RunningUploads, AutoUpload,
 * and UploadToAlbumModal, which each used to define their own emoji-string
 * version of this exact same status → icon mapping.
 */
const UploadStatusIcon = ({ status, fileType, isDuplicate, size = 14, style }) => {
  const props = { size, strokeWidth: 2, style };
  if (status === "done" && isDuplicate) return <RotateCcw {...props} />;
  switch (status) {
    case "checking": return <Search {...props} />;
    case "compressing": return <Settings {...props} />;
    case "uploading": return <Radio {...props} />;
    case "retrying": return <RefreshCw {...props} />;
    case "done": return <CheckCircle2 {...props} color="#16a34a" />;
    case "failed": return <XCircle {...props} color="#e53935" />;
    default: return fileType?.startsWith("video/") ? <Video {...props} /> : <ImageIcon {...props} />;
  }
};

export default UploadStatusIcon;
